<template>
  <v-app>
    <t-toolbar></t-toolbar>
    <v-content>
      <router-view />
    </v-content>

    <t-footer v-show="$route.path === '/account' ? false : true"></t-footer>
  </v-app>
</template>

<script>
import TToolbar from "../../components/shared/Toolbar";
import TFooter from "../../components/shared/Footer";

export default {
  name: "Start",
  components: {
    TToolbar,
    TFooter,
  },
};
</script>
